import { Option } from '../services/ducks/schedulesDuck';

export const findSavedOptionFromValue = (
  options: Option[],
  toEqual: string
) => {
  return options.find(option => option.value === toEqual) || null;
};
